<template>
  <div class="yeMast">
    <full-page :options="options" ref="page">
     <!--第一屏-->
      <div class="section">
        <div :class="{ box1: nav == '1', box6: nav == '2', box7: nav == '3' }" class="box" >
            <page1 :up2="up2"  @clicknav="clicknavclick"/>
        </div>
      </div>
     <!--第二屏-->
      <div class="section">
        <div class="box2 box">
           <page2 :ani_left="ani_left"/>
        </div>
      </div>
      <!--第三屏-->
      <div class="section">
        <div class="box3 box">
          <page3 :ani_right="ani_right"/>
        </div>
      </div>
      <div class="section">
        <div class="box4 box">
          <page4 :ani_top="ani_top"/>
        </div>
      </div>
      <div class="section">
        <div class="box5 box">
          <page5 :ani_left_5="ani_left_5" :ani_right_5="ani_right_5"/>
        </div>
      </div>
    </full-page>
  </div>
</template>
<script>
import page1 from '../../components/page1'
import page2 from '../../components/page2'
import page3 from '../../components/page3'
import page4 from '../../components/page4'
import page5 from '../../components/page5'

export default {
  name: 'yeMast',
  data() {
    return {
      nav: '1',
      options: {
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          navigation: true,//是否显示导航，默认为false
          navigationPosition: 'right',//导航小圆点的位置
          scrollBar: false,
          keyboardScrolling: false,//是否可以使用键盘方向键导航，默认为true
          continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
          // menu: '#nav',
          verticalCentered: false,
          lockAnchors: true,
          onLeave: this.onLeave, //滚动前的回调函数，
          // navigation: true,
          anchors: ['page1', 'page2', 'page3','page4', 'page5'],
          // sectionsColor: ['#41b883', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', '#ee1a59', '#2c3e4f', '#ba5be9', '#b4b8ab']
      },
      up2: false,
      ani_left: false,
      ani_right: false,
      ani_top: false,
      ani_left_5: false,
      ani_right_5: false
    }
  },
  components: {
    page1,
    page2,
    page3,
    page4,
    page5
  },
  methods: {
    clicknavclick (obj) {
      console.log(obj)
      this.nav = obj
    },
    afterLoad: function(origin, destination, direction) {
      console.log(destination);
      if (destination.anchor === 'page1') {
        this.up2 = true
        this.ani_left = false
        this.ani_right = false
        this.ani_top =false
        this.ani_left_5 = false
        this.ani_right_5 = false
      } else if (destination.anchor === 'page2') {
        this.up2 = false
        this.ani_left = true
        this.ani_right = false
        this.ani_top =false
        this.ani_left_5 = false
        this.ani_right_5 = false
      } else if (destination.anchor === 'page3') {
        this.up2 = false
        this.ani_left = false
        this.ani_right = true
        this.ani_top =false
        this.ani_left_5 = false
        this.ani_right_5 = false
      } else if (destination.anchor === 'page4') {
        this.up2 = false
        this.ani_left = false
        this.ani_right = false
        this.ani_top =true
        this.ani_left_5 = false
        this.ani_right_5 = false
      } else if (destination.anchor === 'page5') {
        this.up2 = false
        this.ani_left = false
        this.ani_right = false
        this.ani_top = false
        this.ani_left_5 = true
        this.ani_right_5 = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "./yeMast.less";

</style>


// WEBPACK FOOTER //
// src/view/yeMast/yeMast.vue